import mermaid from 'mermaid';
import { useEffect } from 'react';

mermaid.initialize({});

export type MermaidChartProps = {
  chart: string;
  id: string;
};

export const MermaidChart = ({ chart, id }: MermaidChartProps) => {
  useEffect(() => {
    document.getElementById(id)?.removeAttribute('data-processed');
    mermaid.contentLoaded();
  }, [chart, id]);

  return (
    <div className="mermaid" id={id}>
      {chart}
    </div>
  );
};
